import React, { useLayoutEffect, useRef, useState } from 'react';
import { Form, Nav } from 'react-bootstrap';

/*
 * Barra dei tab che sta sempre su una riga (regola SUI): se le voci non entrano si riducono prima font e spazi
 * (livello 1); se anche cosi' non bastano, si passa alla visualizzazione compatta, un menu a tendina (livello 2).
 * Si rimisura a ogni cambio di larghezza dello spazio disponibile.
 */
export const NavTabAdattiva = ({ tabs, activeKey, onSelect }) => {
    const contenitore = useRef(null);
    const nav = useRef(null);
    const [livello, setLivello] = useState(0);
    const [larghezza, setLarghezza] = useState(0);
    const ultima = useRef(0);

    useLayoutEffect(() => {
        const el = contenitore.current;
        if (!el || typeof ResizeObserver === 'undefined') return undefined;
        const osserva = new ResizeObserver(([voce]) => {
            const w = Math.round(voce.contentRect.width);
            if (w === ultima.current) return;
            ultima.current = w;
            setLarghezza(w);
            setLivello(0);
        });
        osserva.observe(el);
        return () => osserva.disconnect();
    }, []);

    useLayoutEffect(() => {
        const el = nav.current;
        if (livello < 2 && el && el.scrollWidth > el.clientWidth + 1) setLivello((l) => l + 1);
    }, [livello, larghezza, tabs.length]);

    return (
        <div ref={contenitore}>
            {livello >= 2 ? (
                <Form.Select
                    className="sid-tabs-compatto"
                    aria-label="Sezione"
                    value={activeKey}
                    onChange={(e) => onSelect(e.target.value)}
                >
                    {tabs.map((t) => <option key={t.id} value={t.id.toLowerCase()}>{t.name}</option>)}
                </Form.Select>
            ) : (
                <Nav ref={nav} as="ul" className={`nav-tabs sid-tabs-adattiva ${livello === 1 ? 'sid-tabs--ridotto' : ''}`} style={{ border: 'none' }}>
                    {tabs.map((t) => (
                        <Nav.Item as="li" key={t.id} className="tabMenu">
                            <Nav.Link eventKey={t.id.toLowerCase()}>{t.name}</Nav.Link>
                        </Nav.Item>
                    ))}
                </Nav>
            )}
        </div>
    );
};

export default NavTabAdattiva;
